import { render } from "./Ethiopian_Date_Picker.vue?vue&type=template&id=db74d566&scoped=true"
import script from "./Ethiopian_Date_Picker.vue?vue&type=script&lang=js"
export * from "./Ethiopian_Date_Picker.vue?vue&type=script&lang=js"

import "./Ethiopian_Date_Picker.vue?vue&type=style&index=0&id=db74d566&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db74d566"]])

export default __exports__